var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.datasetId)?_c('DisplayApplications',{attrs:{"dataset-id":_vm.datasetId}}):_vm._e(),_vm._v(" "),_c('PluginList',{attrs:{"dataset-id":_vm.datasetId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }